import { create } from "zustand";
import { ChairModel } from "./ChairContext";

export type CartItem = {
    chair: ChairModel;
    count: number;
    id: string;
};

export type Cart = {
    cart: Array<CartItem>;
    note: string;
    setNote: (note: string) => void;
    setCart: (items: Array<CartItem>) => void;
    addItem: (item: CartItem) => void;
    changeCount: (id: string, count: number) => void;
    removeItem: (id: string) => void;
    empty: () => void;
    loadFromCart: boolean;
    setLoadFromCart: (loadFromCart: boolean) => void;
};

export const useCart = create<Cart>()((set) => ({
    cart: [],
    note: "",
    setNote: (note) => set(() => ({ note: note })),
    setCart: (items) =>
        set(() => ({
            cart: items,
        })),
    addItem: (item) =>
        set((state) => {
            const cart = [...state.cart];
            const index = cart.findIndex((ci) => ci.id === item.id);
            if (index >= 0) {
                cart[index] = { ...cart[index], count: cart[index].count + item.count };
            } else {
                cart.push(item);
            }
            return { cart: cart };
        }),
    removeItem: (id) =>
        set((state) => {
            const cart = state.cart.filter((item) => item.id !== id);
            return { cart: cart };
        }),
    changeCount: (id, count) =>
        set((state) => {
            const cart = [...state.cart];
            const index = cart.findIndex((ci) => ci.id === id);
            if (index >= 0) {
                cart[index] = { ...cart[index], count: count };
            }
            return { cart: cart };
        }),
    empty: () =>
        set(() => ({
            cart: [],
        })),
    loadFromCart: false,
    setLoadFromCart: (loadFromCart) => set(() => ({ loadFromCart: loadFromCart })),
}));
